import cx from "classnames";
import React from "react";

const CLASS_ROOT = "dropdown__divider";

const DropdownDivider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} {...other} />;
};

DropdownDivider.displayName = "DropdownDivider";

export { DropdownDivider };
